import React, { useState, useRef, useEffect } from "react";
import InputBase from "../form/inputs/InputBase";
import PrimaryBtn from "../button/PrimaryBtn";
import MealExternalPage from "./MealExternalPage";
import logo from "../../assets/images/Logo/web_logo.png";
import DecorativeSquares from "../ui/DecorativeSquares";
import Service from "./setUpPages/Service";
import Mealplan from "./setUpPages/Mealplan";
import Addnewmeal from "../Modals/Addnewmeal";
import EditMeal from "../Modals/EditMeal";
import Mealdetail from "../../pages/Mealdetail";
import AddAddress from "./setUpPages/AddAddress";
import { useNavigate } from "react-router-dom";
import GoogleMapProvider from "../../utils/GoogleMapProvider";
const Setup = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(() => {
    const savedTab = localStorage.getItem("setup_tab");
    return savedTab !== null ? Number(savedTab) : 0;
  });

  const [screen, setScreen] = useState("SETUP");
  const [mealPlans, setMealPlans] = useState([]);

  const tabs = ["Service Identity", "Meal Plans", "Address"];

  useEffect(() => {
    // agar fresh visit ho to
    setTab(0);
    localStorage.setItem("setup_tab", 0);
  }, []);

  useEffect(() => {
    localStorage.setItem("setup_tab", tab);
  }, [tab]);

  // ================= DEVICE UPLOAD =================

  if (screen === "MEAL_EXTERNAL") {
    return (
      <MealExternalPage
        mealPlans={mealPlans}
        setMealPlans={setMealPlans}
        onNext={() => {
          setScreen("SETUP");
          setTab(2);
        }}
        onAddMeal={() => setScreen("ADD_MEAL")}
        onEditMeal={() => setScreen("EDIT_MEAL")}
        onLink={() => setScreen("MEAL_DETAIL")}
        onBack={() => setScreen("SET_UP")}
        isInternalFlow={true}
      />
    );
  }

  if (screen === "ADD_MEAL") {
    return (
      <Addnewmeal
        onBack={() => setScreen("MEAL_EXTERNAL")}
        onSave={(mealData) => {
          setMealPlans((prev) => [...prev, mealData]);
          setScreen("MEAL_EXTERNAL");
        }}
      />
    );
  }

  if (screen === "EDIT_MEAL") {
    return (
      <EditMeal
        onBack={() => setScreen("MEAL_EXTERNAL")}
        onSave={(mealData) => {
          setMealPlans((prev) => [...prev, mealData]);
          setScreen("MEAL_EXTERNAL");
        }}
      />
    );
  }

  if (screen === "MEAL_DETAIL") {
    return <Mealdetail onBack={() => setScreen("MEAL_EXTERNAL")} />;
  }

  return (
    <div className="min-h-screen relative overflow-hidden lg:bg-gradient-to-br lg:from-orange-50 lg:to-orange-100 flex flex-col items-center">
      <DecorativeSquares />

      {/* ================= BRAND HEADER ================= */}
      <div className="w-full flex flex-col items-center justify-center pt-10 pb-16">
        <img
          src={logo}
          alt="web_logo"
          className="w-24 h-24 object-contain mb-3"
        />
        <h1 className="text-xl font-semibold text-gray-800">
          Your Kitchen, Our Management
        </h1>
        <p className="text-gray-500 text-sm mt-1">
          You Cook, We Manage the Rest
        </p>
      </div>

      {/* ================= MAIN CARD ================= */}
      <div className="w-full px-4 -mt-10">
        <div className="bg-white w-full max-w-7xl mx-auto rounded-2xl shadow-xl p-4">
          {/* TABS */}
          <div className="flex gap-8 border-b mb-8">
            {["Service Identity", "Meal Plans", "Address"].map((t, i) => (
              <button
                key={i}
                className={`pb-3 text-sm font-medium transition ${
                  tab === i
                    ? "border-b-2 border-[#FF6943] text-[#FF6943]"
                    : "text-gray-400 hover:text-gray-600"
                }`}
              >
                {t}
              </button>
            ))}
          </div>

          {/* ================= TAB 1 ================= */}
          {tab === 0 && (
            <>
              <Service setTab={setTab} />
              {/* ================= Actions ================= */}
            </>
          )}

          {/* ================= TAB 2 ================= */}
          {tab === 1 && (
            <>
              <Mealplan
                setTab={setTab}
                setScreen={setScreen}
                isSetupFlow={true}
              />
            </>
          )}

          {/* ================= TAB 3 ================= */}
          {tab === 2 && (
            <>
              <AddAddress setTab={setTab} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Setup;
